import React from "react";

const CarouselContent = ({ children }) => {
  return <div style={{ width: "100%", height: "100vh" }}>{children}</div>;
};

export default CarouselContent;
